function validate (value) {
  var cnpj = value.replace(/[^\d]+/g, '')
  var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  if (cnpj.match(/^(\d)\1+$/)) return false

  for (var i = 0, n = 0; i < 12; n += parseInt(cnpj.charAt(i)) * b[++i]);

  if (parseInt(cnpj.charAt(12)) !== (((n %= 11) < 2) ? 0 : 11 - n)) return false

  for (i = 0, n = 0; i <= 12; n += parseInt(cnpj.charAt(i)) * b[i++]);

  if (parseInt(cnpj.charAt(13)) !== (((n %= 11) < 2) ? 0 : 11 - n)) return false

  return true
}

export default validate



// WEBPACK FOOTER //
// ./src/rules/cnpj.js